


























































































































import Vue from "vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import Multiselect from "@/components/ui/Multiselect.vue";

import { Element, Rolle } from "@/types";
import { alertError } from "@/services/ErrorAlert";
import { erklServiceInstance } from "@/services/ErklService";

import PubSub from "pubsub-js";
import { Ansprechpartner } from "@/types/Ansprechpartner";
import ValidationService from "@/services/ValidationService";
import AlertService from "@/services/libs/AlertService";

export default Vue.extend({
  name: "StammdatenTab",
  components: {
    Fieldset,
    Multiselect,
  },
  props: {
    /** Ansprechpartner */
    value: {
      type: Object as () => Ansprechpartner,
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      institutionen: [] as Element[],
      rollen: [] as Rolle[],
    };
  },
  mounted() {
    this.isLoading = true;

    Promise.all([
      erklServiceInstance
        .getInstitutionOptions()
        .then((data: Element[]) => (this.institutionen = data)),

      erklServiceInstance
        .getRollen()
        .then((data: Rolle[]) => (this.rollen = data)),
    ])
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  computed: {
    name: {
      // getter
      get: function () {
        return this.value.namen ? this.value.namen[0].bez : "";
      },
      // setter
      set: function (newValue: string) {
        this.value.namen[0].bez = newValue;
      },
    },
  },
  methods: {
    bearbeiten: function (mode: boolean) {
      PubSub.publish("bearbeiten", mode);
    },
    onValidateAndSave: function () {
      const errors: string[] = [];
      if (!ValidationService.validEmail(this.value.email)) {
        errors.push("Die Emailaddresse ist nicht valide!");
      }
      if (!this.name || !this.name.trim()) {
        errors.push("Der Name darf nicht leer sein!");
      }
      if (!this.value.institutionen || this.value.institutionen.length === 0) {
        errors.push("Die Institution darf nicht leer sein!");
      }
      if (!this.value.rollen || this.value.rollen.length === 0) {
        errors.push("Die Rolle darf nicht leer sein!");
      }

      if (errors.length === 0) {
        this.$emit("save");
      } else {
        AlertService.error(
          "Es gab folgende Fehler bei der Validierung:",
          ...errors,
        );
      }
    },
  },
});
